<div class="supply-overview-page">
  <div class="page-header">
    <div>
      <p class="eyebrow">Supply Operations</p>
      <h2>Supply Overview</h2>
      <p class="subtitle">Monitor catalog readiness, dispatch flow, revenue signals, and high-volume routes from one operational view.</p>
    </div>
    <button mat-stroked-button (click)="loadOverview()">Refresh</button>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <section class="stats-grid">
    <article class="stat-card primary">
      <span>Product Types</span>
      <strong>{{ productTypes.length }}</strong>
      <small>Catalog groups currently configured</small>
    </article>
    <article class="stat-card accent">
      <span>Catalog Items</span>
      <strong>{{ productItemCount }}</strong>
      <small>Individual supply items across all types</small>
    </article>
    <article class="stat-card warning">
      <span>Total Dispatches</span>
      <strong>{{ analytics?.totalDispatches || dispatchRows.length }}</strong>
      <small>Recorded dispatch history volume</small>
    </article>
    <article class="stat-card success">
      <span>Total Units</span>
      <strong>{{ totalUnits }}</strong>
      <small>Units moved across dispatch records</small>
    </article>
  </section>

  <section class="hero-card">
    <div>
      <span class="hero-label">Commercial Snapshot</span>
      <h3>{{ analytics?.totalRevenue || analytics?.grossAmount || 0 | number:'1.0-0' }}</h3>
      <p>Total supply revenue captured from dispatch activity.</p>
    </div>
    <div>
      <span class="hero-label">Commission</span>
      <h3>{{ analytics?.totalCommission || 0 | number:'1.0-0' }}</h3>
      <p>Commission exposure across recorded dispatches.</p>
    </div>
    <div>
      <span class="hero-label">Net Value</span>
      <h3>{{ analytics?.totalNetAmount || analytics?.netAmount || 0 | number:'1.0-0' }}</h3>
      <p>Net value remaining after commission.</p>
    </div>
  </section>

  <section class="content-grid">
    <article class="panel">
      <div class="panel-head">
        <h3>Recent Dispatches</h3>
        <span>Latest 6 records</span>
      </div>
      <div class="dispatch-list" *ngIf="recentDispatches.length; else noDispatches">
        <div class="dispatch-item" *ngFor="let row of recentDispatches">
          <div>
            <strong>{{ row.productItemName || row.productTypeName || 'Supply Item' }}</strong>
            <p>{{ row.buyerName || 'Buyer not set' }}</p>
          </div>
          <div class="dispatch-meta">
            <span>{{ row.origin || 'Unknown' }} → {{ row.destination || 'Unknown' }}</span>
            <small>{{ row.dispatchDate | date:'mediumDate' }} · {{ row.unitCount || 0 }} units</small>
          </div>
        </div>
      </div>
    </article>

    <article class="panel compact">
      <div class="panel-head">
        <h3>Top Moving Items</h3>
        <span>By unit volume</span>
      </div>
      <div class="metric-list" *ngIf="topProducts.length; else noProducts">
        <div class="metric-row" *ngFor="let row of topProducts">
          <strong>{{ row.label }}</strong>
          <span>{{ row.value }} units</span>
        </div>
      </div>
    </article>

    <article class="panel compact">
      <div class="panel-head">
        <h3>Route Highlights</h3>
        <span>Most-used routes</span>
      </div>
      <div class="metric-list" *ngIf="routeHighlights.length; else noRoutes">
        <div class="metric-row" *ngFor="let row of routeHighlights">
          <strong>{{ row.label }}</strong>
          <span>{{ row.value }} dispatches</span>
        </div>
      </div>
    </article>
  </section>
</div>

<ng-template #noDispatches>
  <p class="muted">No dispatch records available yet.</p>
</ng-template>

<ng-template #noProducts>
  <p class="muted">No high-volume product data yet.</p>
</ng-template>

<ng-template #noRoutes>
  <p class="muted">No route activity recorded yet.</p>
</ng-template>
